import { singleton, inject } from "tsyringe";

// shared
import DateAdapter from "@/shared/libs/date/DateAdapter";

// entities
import type { AcademyRegistrationResponseDto } from "@/entities/academy-registration-request/domain/dtos";
import { UserBehavior } from "@/entities/user/models/behaviors/UserBehavior";

// features
import type { PendingRegistrationUserProps } from "@/features/pending-registration/models/interface";

@singleton()
export class PendingRegistrationUserConverter {
    constructor(
        @inject(UserBehavior) private readonly userBehavior: UserBehavior,
        @inject(DateAdapter) private readonly dateAdapter: DateAdapter,
    ) {}

    public convert = (
        registrationRequests: AcademyRegistrationResponseDto[],
    ): PendingRegistrationUserProps[] => {
        const convertedPendingRegistrationUserList = registrationRequests.map(
            (registrationRequest) => {
                return {
                    registrationId: registrationRequest.id,
                    userId: registrationRequest.user.id,
                    name: registrationRequest.user.name,
                    unConvertedType: registrationRequest.user.type,
                    type: this.userBehavior.isUserDto(registrationRequest.user)
                        ? this.userBehavior.mappingUserTypeInString(registrationRequest.user)
                        : "미정",
                    registrationDate: this.dateAdapter.formatZoned(
                        registrationRequest.createdAt,
                        "Asia/Seoul",
                        "MM-dd",
                    ),
                };
            },
        );

        return convertedPendingRegistrationUserList;
    };
}
